import { fetchWithBearer } from '@braincube/jwt-browser';

function modifyUserPreference(preference, value) {
    return fetchWithBearer(`https://${window.BC_API_ENDPOINTS_CONF.preference}/users/general/${preference}`, {
        body: value,
        headers: new Headers({ 'Content-Type': 'text/plain' }),
        method: 'PUT',
    }).then((response) => {
        if (response.ok) {
            return Promise.resolve(response);
        }

        return Promise.reject(response);
    });
}

export default modifyUserPreference;
